import { QuestionBase } from './question-base.model';

export class TicketsQuestion extends QuestionBase<string> {
    controlType = 'tickets';
    id: string;
    disabled: boolean;
    visible: string;
    constructor(options: {} = {}) {
        super(options);
        this.value = options['value'] || false;
        this.id = options['id'];
        this.disabled = options['disabled'] || false;
        this.visible = (options['visible'] == undefined) ? true : options['visible'];
    }
}